import PropTypes from "prop-types";

export const CustomizedTick = ({ color, x, y, payload }) => {
  const words = String(payload.value).split(" ");
  return (
    <text x={x} y={y + 10} textAnchor="middle" fill={color}>
      {words.map((word, index) => (
        <tspan key={`${word}_${index}`} x={x} dy={index === 0 ? 0 : 14}>
          {word}
        </tspan>
      ))}
    </text>
  );
};

CustomizedTick.propTypes = {
  color: PropTypes.string,
  payload: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  x: PropTypes.number,
  y: PropTypes.number,
};
